import { OrderedListOutlined } from '@ant-design/icons';
import {
  CustomWarningsRule,
  IWidgetType,
  RepeatableRangeRule,
  RequiredRule,
  WidgetCategory,
  WidgetMainType,
  tran,
} from '@framework/engine';
import {
  IMultiPreferenceWidget,
  WidgetMultiPreferenceType,
} from './IMultiPreferenceWidget';
import { MultiPreferenceConfigComponent } from './MultiPreferenceConfigComponent';
import { MultiPreferenceWidgetConfigSchema } from './MultiPreferenceConfigSchema';
import { MultiPreferenceWidgetComponent } from './MultiPreferenceWidgetComponent';
import { createMultiPreferenceFormSchema } from './createMultiPreferenceFormSchema';
import { getMultiPreferenceWidgetReferences } from './references/getMultiPreferenceWidgetReferences';

declare module '@framework/engine/src/schema/widgets/Widget' {
  export enum WidgetType {
    MultiPreference = 'multiPreference',
  }
}

export const MultiPreferenceWidgetType: IWidgetType<IMultiPreferenceWidget> = {
  type: WidgetMultiPreferenceType,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Preferenze Multiple',
  icon: <OrderedListOutlined />,
  hasValue: true,
  // L'idratazione di default restituisce già i valori corretti
  // hydrate: hydrateMultiPreferenceWidget,
  getReference: getMultiPreferenceWidgetReferences,
  getSiblingReferences: () => [],
  formComponent: MultiPreferenceWidgetComponent,
  createFormSchema: createMultiPreferenceFormSchema,
  previewComponent: MultiPreferenceWidgetComponent,
  configValidator: MultiPreferenceWidgetConfigSchema,
  configComponent: MultiPreferenceConfigComponent,
  configOptions: {
    removeCollapsePanel: true,
  },
  // Traduzioni
  translationSchema: tran.widget({
    label: tran.rte(),
    helpText: tran.rte(),
  }),
  rules: [RequiredRule, RepeatableRangeRule, CustomWarningsRule],
};
